export default __webpack_public_path__ + "static/media/cot2.f28269bc.jpg";